import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=0b0f7f15&scoped=true"
import script from "./addForm.vue?vue&type=script&lang=js"
export * from "./addForm.vue?vue&type=script&lang=js"
import style0 from "./addForm.vue?vue&type=style&index=0&id=0b0f7f15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f7f15",
  null
  
)

export default component.exports